import(/* webpackMode: "eager", webpackExports: ["CalculatorPageContent"] */ "/app/apps/web/components/calculators/CalculatorPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SunSignCalculatorClient"] */ "/app/apps/web/components/calculators/SunSignCalculatorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
